import { render } from "./NOMessageDetailsWrapper.vue?vue&type=template&id=3704e1da"
import script from "./NOMessageDetailsWrapper.vue?vue&type=script&lang=js"
export * from "./NOMessageDetailsWrapper.vue?vue&type=script&lang=js"

import "./NOMessageDetailsWrapper.vue?vue&type=style&index=0&id=3704e1da&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "3704e1da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3704e1da', script)) {
    api.reload('3704e1da', script)
  }
  
  module.hot.accept("./NOMessageDetailsWrapper.vue?vue&type=template&id=3704e1da", () => {
    api.rerender('3704e1da', render)
  })

}

script.__file = "src/components/no-message/NOMessageDetailsWrapper.vue"

export default script